export default window.filters = {
    formatGlobal (value, columnType) {

    if (columnType === 'percent') {
        if ($.isNumeric(value)) {
            value = (value * 100).toFixed(0);


            if (value < 1) {
                return '< 1%';
            } else {
                return value + '%';
            }
        } else {
            return value;
        }

    } else if (columnType === 'number') {
        if (value) {
            return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        }
    } else if (columnType === 'currency') {
        if (value) {
            return '$' + Math.round(value).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        }
    }

    return value;

}, 
currency (value) {
    if (value !== null || value !== undefined || value !== '') {
        return '$' + value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    } else {
        return value;
    }
},
addCommas (value) {
    if (value !== null || value !== undefined || value !== '') {
        return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    } else {
        return value;
    }
}
}